import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IAppOnlyStore } from 'stores/AllStores';
import { Question } from './Question';
import { LoadingFullScreen } from 'components/indicator';

// Styles
const s = require('./LeadQuestions.css');

// Component
@inject('store')
@observer
export class LeadQuestions extends React.Component<IAppOnlyStore, {}> {
  constructor(props: IAppOnlyStore) {
    super(props);
  }

  public render() {
    const { store } = this.props;

    return (
      <div className={s.questions}>
        {store.question.questionWithOptionInfo.map((question, i) => {
          return question !== null && typeof question.id !== 'undefined' ? (
            <Question
              index={i}
              child={false}
              key={question.id}
              questionInfo={question}
            >
              {typeof question.children !== 'undefined' &&
                question.children !== null &&
                question.children.length > 0 && (
                  <div>
                    {question.children.map((childQuestion, c) => {
                      return childQuestion !== null &&
                        typeof childQuestion.id !== 'undefined' ? (
                        <Question
                          index={c}
                          child={true}
                          key={childQuestion.id}
                          questionInfo={childQuestion}
                        />
                      ) : null;
                    })}
                  </div>
                )}
            </Question>
          ) : null;
        })}

        <LoadingFullScreen
          active={store.question.loading || store.answer.loading}
          fitInContainer={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/LeadQuestions.tsx